// src/layouts/EmployeeLayout.jsx
import React, { Suspense, lazy } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import ManagerSideMenu from "./components/sideMenu/SideMenu.jsx"; // keep your existing side menu
import CompletedTasks from "./pages/completedTasks/CompletedTasks.jsx";
import TasksCalendar from "./pages/tasksCalendar/TasksCalendar.jsx";

// Lazy-load pages (makes initial bundle lighter)
const EmployeeHome = lazy(() => import("./pages/homePage/EmployeeHome.jsx"));
/* const AssignTask = lazy(() => import("../components/assign/AssignTask.jsx")); */ // optional assign UI
const Notifications = lazy(() =>
  import("./pages/notifications/Notifications.jsx")
);
/* const Account = lazy(() => import("../pages/account/Account.jsx")); */

export default function EmployeeLayout() {
  return (
    <div className="layout" style={{ display: "flex", minHeight: "100vh" }}>
      {/* Sidebar */}
      <aside className="layout-sidebar" style={{ width: 260 }}>
        <ManagerSideMenu />
      </aside>

      {/* Main content */}
      <main className="layout-main" style={{ flex: 1, padding: "1rem 2rem" }}>
        <Suspense fallback={<div>Loading...</div>}>
          <Routes>
            {/* Redirect root of employee area to tasks (employee dashboard) */}
            <Route path="/" element={<Navigate to="tasks" replace />} />

            {/* Employee "home" — Kanban of assigned tasks */}
            <Route path="tasks" element={<EmployeeHome />} />
            <Route path="tasks-calendar" element={<TasksCalendar />} />

            {/* Assignments UI (optional) */}
            {/* <Route path="assignments" element={<AssignTask />} /> */}

            {/* Notifications & Account pages (you can replace placeholders) */}
            <Route path="notifications" element={<Notifications />} />
            {/* <Route path="account" element={<Account />} /> */}
            <Route path="/completed-tasks" element={<CompletedTasks />} />

            {/* Fallback */}
            <Route path="*" element={<h2>404 - Page not found</h2>} />
          </Routes>
        </Suspense>
      </main>
    </div>
  );
}
